export default "__VITE_ASSET__sXPn7NQp__"